import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Snapshot } from "zephyr-edge-contract";

// Namespace filter store
interface NamespaceFilterState {
  filterZeOnly: boolean;
  toggleZeFilter: () => void;
}

export const useNamespaceFilterStore = create<NamespaceFilterState>()(
  persist(
    (set, get) => ({
      filterZeOnly: false,
      toggleZeFilter: () => set({ filterZeOnly: !get().filterZeOnly }),
    }),
    {
      name: 'namespace-filter-storage',
    },
  ),
);

// Ze value store
interface ZeValueStore {
  namespace: 'ze_snapshots' | 'ze_envs' | 'ze_files' | null;
  key: string | null;
  zeValue: Snapshot | null;
  snapshotId: string | null;
  sourceNamespaceId: string | null;
  isSnapshotMode: boolean;
  setNamespace: (namespace: 'ze_snapshots' | 'ze_envs' | 'ze_files') => void;
  setKey: (key: string) => void;
  setZeValue: (zeValue: Snapshot) => void;
  setSnapshotMode: (snapshotId: string, sourceNamespaceId: string) => void;
  clearSnapshotMode: () => void;
  clearZeValue: () => void;
}

export const useZeValueStore = create<ZeValueStore>()(
  persist(
    (set, get) => ({
      namespace: null,
      key: null,
      zeValue: null,
      snapshotId: null,
      sourceNamespaceId: null,
      isSnapshotMode: false,
      setNamespace: (namespace: 'ze_snapshots' | 'ze_envs' | 'ze_files') => set({ namespace }),
      setKey: (key: string) => set({ key }),
      setZeValue: (zeValue: Snapshot) => set({ zeValue }),
      setSnapshotMode: (snapshotId: string, sourceNamespaceId: string) => 
        set({ 
          snapshotId, 
          sourceNamespaceId,
          isSnapshotMode: true 
        }),
      clearSnapshotMode: () => 
        set({ 
          snapshotId: null, 
          sourceNamespaceId: null,
          isSnapshotMode: false 
        }),
      clearZeValue: () => set({ zeValue: null, namespace: null, key: null }),
    }),
    {
      name: 'ze-value-storage',
      storage: {
        getItem: (name) => {
          const str = sessionStorage.getItem(name);
          if (!str) return null;
          return JSON.parse(str);
        },
        setItem: (name, value) => {
          sessionStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: (name) => {
          sessionStorage.removeItem(name);
        },
      },
    },
  ),
);
